// ============================================
// PULSE INSURANCE PLATFORM - FIREBASE CONFIG
// ============================================

import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions, httpsCallable } from 'firebase/functions';

// REPLACE WITH YOUR FIREBASE CONFIG FROM FIREBASE CONSOLE
const firebaseConfig = {
    apiKey: "AIzaSyBhVK1dsgVSeM63DfVCdH_UKmcG82w9I8M",
    authDomain: "pulse-insurance.firebaseapp.com",
    projectId: "pulse-insurance",
    storageBucket: "pulse-insurance.firebasestorage.app",
    messagingSenderId: "939234292639",
    appId: "1:939234292639:web:6a48c740c6eb089dd0c3aa"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

export const callFunction = async (name, data) => {
    const fn = httpsCallable(functions, name);
    try {
        const result = await fn(data);
        return result.data;
    } catch (error) {
        console.error('Error calling ' + name + ':', error);
        throw error;
    }
};

export default app;
